import { useContext, useEffect } from 'react'
import HeaderContext from '../context/HeaderContext'
import ShallowHeader from './ShallowHeader'

function Header(props) {
    const { setHeaderData } = useContext(HeaderContext)

    // Keep HeaderTopLevel informed for things like title display, etc.
    useEffect(() => {
        // Mark that SSR already injected meta so HeaderTopLevel can avoid duplicating <Head> tags
        setHeaderData({ ...props, ssrInjected: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Server-render only the meta/links in <Head> so they appear in View Page Source.
    // Defer all scripts to HeaderTopLevel to avoid double-injecting tracking pixels.
    return <ShallowHeader {...props} renderMeta={true} renderScripts={false} />
}

export default Header
